/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamStatisticsV2 = {
    properties: {
        teamStatistics: {
            type: 'array',
            contains: {
                type: 'SingleTeamStatistic',
            },
            isRequired: true,
        },
        statistic: {
            type: 'StatisticV2',
            isRequired: true,
        },
    },
} as const;
